module.exports = __webpack_public_path__ + "img/sarah_broecker_5.dfe353f8.jpg";